import classes from "./Vocabulary.module.css";
import { Link } from 'react-scroll';


const Vocabulary = ({ item }: { item: any }) => {
    /*
        - check heading number
        - make toc items links + add id's to headings
    */
    return (
        <div className={classes.vocabularyWrapper}>
            <div className={classes.vocabularyTOC}>
                <h2>Seznam témat</h2>
                <ul>
                    {item.map((c: any) => <li key={c.heading}><Link className={classes.link} to={c.heading} spy={true} smooth={true}>{c.heading}</Link></li>)}
                </ul>
            </div>
            <div className={classes.vocabularyContent}>
                {item.map((c: any) => {
                    return (
                        <>
                            <h3 id={c.heading}>{c.heading}</h3>
                            <div className={classes.vocabularyTermWrapper}>
                                {c.children.map((cc: any) => <div className={classes.vocabularyTerm}>{cc.term}</div>)}
                            </div>
                        </>
                    )
                })}
            </div>
        </div>
    )
}

export default Vocabulary;